import { DatePicker, TimePicker } from 'antd';
import styled from 'styled-components';

// CreateBatch Styles
export const PageContainer = styled.div`
  min-height: 100%;
  background-color: #fcf7f6;
  display: flex;
  flex-direction: column;
  justify-content: center;
  * {
    font-family: ui-sans-serif, system-ui, "sans serif" !important;
  }
  .high-z-index-popup {
    z-index: 10001 !important;
  }
`;

export const Header = styled.div`
  margin-bottom: 32px;
`;

export const HeaderFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h1`
  font-size: 30px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 8px;
`;

export const Subtitle = styled.p`
  color: #1f2937;
`;

export const ReturnButton = styled.button`
  padding: 10px 24px;
  background-color: #000000;
  border: 2px solid #ffffff;
  color: #ffffff;
  border-radius: 12px;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  &:hover {
    background-color: #111827;
  }
`;

export const MainLayout = styled.div`
  display: flex;
  gap: 32px;
`;


export const ContentArea = styled.div`
  flex: 1;
`;

export const ContentCard = styled.div`
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  padding: 24px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 200px);
  max-height: 800px;
`;

export const StepWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 8px;
`;

export const StepContent = styled.div`
  animation: fadeIn 0.5s ease;
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export const FormContainer = styled.div`
  max-width: 672px;
  margin: 0 auto;
  .ant-upload.ant-upload-select {
    display: block !important;
    width: 100% !important;
  }
  .addMore {
    height: 40px;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    color: rgb(219, 57, 31);
    margin-left: ${props => props.isUploadFile && '25%'};
      .anticon {
        margin-right: 20px;
        color: rgb(219, 57, 31);
      }
  }
  .ant-input {
    border-radius: 12px;
    padding-block: 24px;
    &:hover {
      border:  1px solid #e5e7eb !important;
    }
    &:focus {
      border: 2px solid ${props => props.isStepTwo ? '#0092b8' : '#927bf8'} !important;
      box-shadow: none;
    }
  }
`;

export const StepHeader = styled.div`
  text-align: center;
  margin-bottom: 16px;
`;

// export const StepTitle = styled.h2`
//   font-size: 20px;
//   font-weight: 700;
//   color: #1f2937;
//   margin-bottom: 4px;
// `;

export const StepSubtitle = styled.p`
  font-size: 14px;
  color: #4b5563;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
`;

export const Required = styled.span`
  color: #ef4444;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.cols || 3}, 1fr);
  gap: 12px;
  margin-bottom: 16px;
`;

export const OptionCard = styled.div`
  position: relative;
  cursor: pointer;
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  background-color: #ffffff;
  padding: 16px;
  transition: all 0.2s;
  ${props => props.disabled && `
    opacity: 0.3;
    cursor: not-allowed;
  `};
  &:hover {
    border-color: #d1d5db;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }
`;

export const CheckBadge = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  background-color: #ffeb3b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background-color: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
`;

export const CardTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 4px;
`;

export const CardDesc = styled.p`
  font-size: 12px;
  line-height: 1.5;
  color: #6b7280;
`;

export const ChannelButton = styled.button`
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
  cursor: pointer;
  border: 2px solid ${props => props.selected ? '#927BF8' : '#e5e7eb'};
  background-color: ${props => props.selected ? '#927BF8' : '#f9fafb'};
  color: ${props => props.selected ? '#ffffff' : '#4b5563'};
  box-shadow: ${props => props.selected ? '0 10px 15px -3px rgba(0, 0, 0, 0.1)' : 'none'};
  transform: ${props => props.selected ? 'scale(1.05)' : 'scale(1)'};

  &:hover {
    border-color: ${props => props.selected ? '#927BF8' : '#d1d5db'};
    background-color: ${props => props.selected ? '#927BF8' : '#f3f4f6'};
  }
`;

export const SearchWrapper = styled.div`
  position: relative;
`;

export const TemplateCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 12px;
  border: 2px solid ${props => props.selected ? '#0092b8' : '#e5e7eb'};
  background: ${props => props.selected ? 'linear-gradient(to right, #ecfeff, #eff6ff)' : '#ffffff'};
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: ${props => props.selected ? '0 10px 15px -3px rgba(0, 0, 0, 0.1)' : 'none'};

  &:hover {
    border-color: ${props => props.selected ? '#0092b8' : '#d1d5db'};
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }
`;

export const CheckCircle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${props => props.selected ? '#0092b8' : '#d1d5db'};
  background-color: ${props => props.selected ? '#0092b8' : 'transparent'};
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${props => props.selected ? 'scale(1.1)' : 'scale(1)'};
  transition: all 0.2s;
`;

export const NavFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  margin-top: 16px;
  border-top: 2px solid #f3f4f6;
  flex-shrink: 0;
`;

export const NavButton = styled.button`
  padding: 10px 24px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
  cursor: pointer;
  border: none;
  background-color: ${props => props.disabled ? '#f3f4f6' : props.primary ? '#ffeb3b' : '#e5e7eb'};
  color: ${props => props.disabled ? '#9ca3af' : props.primary ? '#000000' : '#374151'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  &:hover {
    background-color: ${props => props.disabled ? '#f3f4f6' : props.primary ? '#ffeb3b' : '#d1d5db'};
    box-shadow: ${props => props.disabled ? 'none' : '0 4px 6px -1px rgba(0, 0, 0, 0.1)'};
    transform: ${props => (props.primary && !props.disabled) ? 'scale(1.05)' : 'none'};
  }
`;

export const ProgressDot = styled.div`
  height: 8px;
  border-radius: 9999px;
  transition: all 0.3s;
  width: ${props => props.active ? '32px' : '8px'};
  background: ${props => props.active ? 'linear-gradient(to right, #927BF8, #06b6d4)' : '#d1d5db'};
`;

export const DropdownContent = styled.div`
  position: absolute;
  z-index: 20;
  margin-top: 8px;
  width: 100%;
  background-color: #ffffff;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  max-height: 256px;
  overflow-y: auto;
`;

export const DropdownItem = styled.button`
  width: 100%;
  padding: 10px 16px;
  text-align: left;
  font-size: 14px;
  transition: all 0.2s;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${props => props.selected ? '#166534' : '#374151'};
  font-weight: ${props => props.selected ? '600' : '400'};
  background-color: ${props => props.selected ? '#f0fdf4' : 'transparent'};

  &:hover {
    background-color: #f9fafb;
  }
`;

export const SampleCard = styled.div`
  margin-bottom: 24px;
  padding: 20px;
  background: linear-gradient(to bottom right, #f0f9ff, #f0fdfa, #ecfeff);
  border-radius: 16px;
  border: 2px solid #bae6fd;

  .standard-batchUpload {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
                0 4px 6px -2px rgba(0, 0, 0, 0.05);
    transform: scale(1.05);
  }
}

`;

export const UploadArea = styled.div`
  border: 2px dashed #d1d5db;
  border-radius: 16px;
  padding: 32px;
  padding-bottom: 4px !important;
  text-align: center;
  transition: all 0.2s;
  background: linear-gradient(to bottom right, rgba(254, 252, 232, 0.5), rgba(255, 247, 237, 0.5));

  &:hover {
    border-color: #facc15;
  }
  .upload-btn-batch{
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    &:hover {
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
                  0 4px 6px -2px rgba(0, 0, 0, 0.05);
      transform: scale(1.05);
    }
  }

  .varUpload-batch{
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 24px 100px;
    align-items: center;
    justify-content: center;

    .anticon {
      margin-right: 5px;
    }
    .ant-upload {
      font-size: 12px !important;
      color: #000;
      text-transform: uppercase;
      cursor: pointer;
      display: flex;
      align-items: center;
    }
  }
`;

export const StyledTag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  background-color: #927BF8;
  color: #ffffff;
  font-size: 14px;
  border-radius: 6px;
  word-break: break-all;
`;

// ProofViewer Styles
export const PVContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

export const PVControlsWrapper = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  padding: 16px;
  margin-bottom: 24px;
`;

export const PVSearchResult = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  padding: 12px;
  max-height: 110px;
  text-align: left;
  overflow: auto;
  position: relative;
  .proof-index {
    position: absolute;
    top: 0;
    right: 0;
    background: ${props => props.active ? '#e4deff' : '#ececec'};
    padding: 4px;
    border-radius: 0px 0px 0px 12px;
    font-size: 13px;
  }
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  p {
    font-size: 13px;
  }
  ::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
  ${props => props.active && `
    border: 1px solid #927BF8;
    background: #927bf81c;
  `};
  :hover {
    cursor: pointer;
    border: 1px solid #927BF8;
    background: #927bf81c;
  }
`;

export const PVFlexRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
`;

export const PVSectionHeader = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  margin-right: 8px;
`;

export const PVTabButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s;
  cursor: pointer;
  border: none;
  background: ${props => props.active ? '#927BF8' : '#f3f4f6'};
  color: ${props => props.active ? '#ffffff' : '#4b5563'};
  box-shadow: ${props => props.active ? '0 4px 6px -1px rgba(0, 0, 0, 0.1)' : 'none'};

  &:hover {
    background: ${props => props.active ? '#927BF8' : '#e5e7eb'};
  }
`;

export const PVProofNumberButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  transition: all 0.2s;
  cursor: pointer;
  border: none;
  background: ${props => props.active ? '#927BF8' : '#f3f4f6'};
  color: ${props => props.active ? '#ffffff' : '#4b5563'};
  box-shadow: ${props => props.active ? '0 4px 6px -1px rgba(0, 0, 0, 0.1)' : 'none'};

  &:hover {
    background: ${props => props.active ? '#927BF8' : '#e5e7eb'};
  }
`;

export const PVViewModeButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${props => props.active ? '#ffffff' : '#f3f4f6'};
  color: ${props => props.active ? '#927BF8' : '#4b5563'};
  border: 2px solid ${props => props.active ? '#927BF8' : 'transparent'};

  &:hover {
    background: ${props => props.active ? '#ffffff' : '#e5e7eb'};
  }
`;

export const PVQuickActionsArea = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
`;

export const PVActionButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s;
  cursor: pointer;
  border: none;
  background: ${props => props.variant === 'cyan' ? '#ecfeff' : props.active ? '#927BF8' : '#f3f4f6'};
  color: ${props => props.variant === 'cyan' ? '#0891b2' : props.active ? '#ffffff' : '#4b5563'};
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
  background: ${props => !props.disableAction 
    ? props.variant === 'cyan' 
      ? '#cffafe' 
      : props.active 
        ? '#927BF8' 
        : '#e5e7eb'
    : ''};
  }
  ${props => props.disableAction && `
    cursor: default;
  `};
`;

export const PVSearchContainer = styled.div`
  flex: 1;
  position: relative;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export const PVResultsGrid = styled.div`
  display: grid;
  grid-template-cols: 1fr 1fr;
  gap: 12px;
  max-height: 240px;
  overflow-y: auto;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
`;

export const PVResultButton = styled.button`
  text-align: left;
  padding: 12px;
  border-radius: 8px;
  border: 2px solid #e5e7eb;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #927BF8;
    background: rgba(146, 123, 248, 0.05);
  }
`;

export const PVPreviewArea = styled.div`
  background: linear-gradient(to bottom right, #f9fafb, #f3f4f6);
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 32px;
  min-height: 600px;
  position: relative;
`;

export const PVNavArrow = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  border: none;
  cursor: pointer;
  z-index: 10;
  
  ${props => props.direction === 'left' ? 'left: 16px;' : 'right: 16px;'}
  
  opacity: ${props => props.disabled ? '0.3' : '1'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};

  &:hover {
    background: ${props => props.disabled ? '#ffffff' : '#f9fafb'};
    box-shadow: ${props => props.disabled ? 'none' : '0 20px 25px -5px rgba(0, 0, 0, 0.1)'};
  }
`;

export const PVDocumentPreview = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const PVPaper = styled.div`
  background: #ffffff;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  transition: all 0.3s;
  width: 100%;
  max-width: ${props => props.mode === 'desktop' ? '768px' : '448px'};
  min-height: 700px;
  canvas {
    height: 100% !important;
    width: 100% !important;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`;

export const PVApprovalSection = styled.div`
  margin-top: 24px;
  background: linear-gradient(to right, #fefce8, #fef9c3);
  border-radius: 12px;
  border: 2px solid #fef08a;
  padding: 24px;
`;

export const PVApprovalFlex = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

export const PVIconBox = styled.div`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  background: #eab308;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PVApprovalButton = styled.button`
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
  cursor: ${props => props.approved ? 'default' : 'pointer'};
  border: none;
  background: ${props => props.approved ? '#c9e165' : '#927BF8'};
  color: ${props => props.approved ? '#1f2937' : '#ffffff'};
  box-shadow: ${props => props.approved ? 'none' : '0 4px 6px -1px rgba(0, 0, 0, 0.1)'};
  ${props => props.disabled && `
    opacity: 0.6;
    filter: grayscale(0.5);
    cursor: not-allowed;
  `}

  &:hover {
    filter: brightness(${props => props.approved ? 1 : 0.8});
  }
`;

// New Schedule Campaign Styles
export const ActionCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background-color: #ffffff;
  margin-bottom: 24px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  background: linear-gradient(to right, #f9fafb, #f3f4f6);
  border-radius: 0.75rem;
  border: 2px solid #e5e7eb;

  .ant-switch-checked{
    background-color: #927BF8 !important;
  }
`;

export const IconBox = styled.div`
  width: 44px;
  height: 44px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.color || '#927BF8'};
`;

export const SendContainer = styled.div`
    display: flex;
    gap: 10px
`;

export const ImmediateCard = styled.div`
  background: ${({enabled}) => enabled ? 'linear-gradient(to bottom right, #ffffff, #f0f9ff, #fdfcea)' : 'linear-gradient(to bottom right, #ffffff, #e7ecef, #f0f0e9)'};;
  border: ${({enabled}) => enabled ? '2px solid #06b6d4' : '2px solid #e5e7eb'};
  border-radius: 20px;
  padding: 24px;
  text-align: center;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // gap: 12px;
  animation: fadeIn 0.3s ease-out;
  width: 50%;
  cursor: pointer;
`;

export const BoltIcon = styled.div`
  width: 56px;
  height: 56px;
  background-color: ${({enabled}) => enabled ? '#06b6d4' :  '#e5e7eb'};
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({enabled}) => enabled ? '#ffffff' :  '#000000'};
  font-size: 24px;
  box-shadow: ${({enabled}) => enabled ? '0 10px 15px -3px rgba(6, 182, 212, 0.3)' :  '0 10px 15px -3px rgb(175 176 176)'};
  margin-bottom: 8px;
`;

export const ConfigSection = styled.div`
  background-color: #ffffff;
  border-radius: 20px;
  border: 1px solid #e5e7eb;
  padding: 24px;
  animation: slideDown 0.3s ease-out;

  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const TabGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 24px;
`;

export const Tab = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px;
  border-radius: 14px;
  font-weight: 700;
  font-size: 15px;
  border: 2px solid ${props => props.active ? '#927BF8' : '#e5e7eb'};
  background-color: ${props => props.active ? '#927BF8' : '#ffffff'};
  color: ${props => props.active ? '#ffffff' : '#4b5563'};
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    border-color: #927BF8;
  }
`;

export const LevelGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-top: 12px;
  margin-bottom: 20px;
`;

export const LevelButton = styled.button`
  padding: 16px;
  border-radius: 14px;
  font-weight: 700;
  font-size: 16px;
  border: 2px solid ${props => props.selected ? '#ffeb3b' : '#e5e7eb'};
  background-color: ${props => props.selected ? '#ffeb3b' : '#ffffff'};
  color: ${props => props.selected ? '#000000' : '#4b5563'};
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    border-color: #ffeb3b;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  width: 100%;

  .ant-calendar-picker-input {
    border-radius: 12px;
    height: 40px !important;
    line-height: 38px;
    padding: 0 12px;
  }
`;

export const StyledTimePicker = styled(TimePicker)`
  width: 100%;

  .ant-time-picker-input {
    border-radius: 12px;
    height: 40px !important;
    line-height: 38px;
    padding: 0 12px;
  }
`;



// ------------------------

export const SidebarWrapper = styled.div`
  width: 256px;
  flex-shrink: 0;
`;

export const Sidebar = styled.div`
  background-color: #18012f;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  padding: 24px;
  position: sticky;
  top: 32px;
  height: calc(100vh - 200px);
  max-height: 800px;
`;

export const StepList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const StepItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

export const StepNumber = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.75rem;
  transition: all 0.3s;
  flex-shrink: 0;
  
  ${props => props.active ? `
    background-color: #c8e066;
    color: #2D1B4E;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    ring: 2px solid #c8e066;
  ` : props.completed ? `
    background-color: #c8e066;
    color: #2D1B4E;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  ` : `
    background-color: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.2);
  `}
`;

export const StepInfo = styled.div`
  flex: 1;
`;

export const StepTitle = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${props => props.active || props.completed ? '#fff' : 'rgba(255, 255, 255, 0.4)'};
`;

export const StepHeaderTitle = styled.div`
  font-size: 1.25rem;      
  font-weight: 700;        
  color: #1f2937;          
  margin-bottom: 0.25rem;
`;

export const StepDescription = styled.div`
  font-size: 0.75rem;
  margin-top: 4px;
  color: ${props => props.active || props.completed ? 'rgba(255, 255, 255, 0.7)' : 'rgba(255, 255, 255, 0.3)'};
`;

export const StepLineWrapper = styled.div`
  margin-left: 16px;
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const StepLine = styled.div`
  width: 2px;
  height: 32px;
  background-color: ${props => props.completed ? '#FFEB3B' : 'rgba(255, 255, 255, 0.2)'};
`;

export const EmailAddresses = styled.div`
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  margin-bottom: 8px;
  padding: 12px;
  .ant-input {
    &:hover {
      border:  none !important;
    }
    &:focus {
      border: none !important;
      box-shadow: none;
    }
  }
`;